define('Store.Selector.ConfirmationModal', [
    'GlobalViews.Confirmation.View',
    'SC.Configuration',
    'Utils'
], function StoreSelectorConfirmatioModal(
    GlobalViewsConfirmationView,
    Configuration,
    Utils
) {
    'use strict';

    function shoppingRedirectToCart() {
        if (Backbone.history.getFragment() !== 'cart') {
            Backbone.history.navigate('/cart', { trigger: true });
        }   
    }

    return new GlobalViewsConfirmationView({
        callBack: shoppingRedirectToCart,
        title: ' ',
        body: Configuration.get('store.selector.messages.confirmationModalMessage'),
        autohide: true,
        confirmLabel: Utils.translate('Go to cart'),
        cancelLabel: Utils.translate('Continue shopping')
    });
});
